module.exports = __webpack_public_path__ + "static/media/facebook-logo.7b947f65.svg";